import { useEffect, useState } from "react";
import { LogRoute, logRouteDefault } from "../types/logRoute";
import apiGetLogRoute from "../api/logRoute/apiGetLogRoute";
import apiAddLogRoute from "../api/logRoute/apiAddLogRoute";
import { AddLogRouteReq } from "../types/logRouteContract";
import { useLoadingContext } from "../contexts/LoadingContext";
import { ErrorI } from "../types/api";
import { useAppContext } from "../contexts/DataContext";

const useLogRoute = (id?: string) => {
  const { incrementLoading, decrementLoading } = useLoadingContext()
  const { dispatch } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(logRouteDefault);

  useEffect(() => {
    isLoading ? incrementLoading() : decrementLoading();
  }, [isLoading])

  const get = async () => {
    if (!id) throw "id is undefined";

    let resData: LogRoute | undefined = undefined;
    let error: ErrorI | undefined = undefined;

    try {
      setIsLoading(true);

      const res = await apiGetLogRoute(id);

      setData(res.json.data);
      resData = res.json.data;
    } catch (err) {
      // TODO!: error handler
      console.error(err);
      if ("message" in (err as ErrorI)) {
        error = err as ErrorI;
      }
    } finally {
      setIsLoading(false);
    }

    return { resData, error };
  };

  const add = async (data: AddLogRouteReq) => {
    let resData: LogRoute | undefined = undefined;
    let error: ErrorI | undefined = undefined;

    try {
      setIsLoading(true);

      const res = await apiAddLogRoute(data);

      setData(res.json.data);

      dispatch({
        type: "ADD",
        payload: {
          type: "logRoutes",
          data: res.json.data,
        },
      });

      dispatch({
        type: "ADD",
        payload: {
          type: "todayRoutes",
          data: res.json.data,
        },
      });

      resData = res.json.data;
    } catch (err) {
      // TODO!: error handler
      console.error(err);
      if ("message" in (err as ErrorI)) {
        error = err as ErrorI;
      }
    } finally {
      setIsLoading(false);
    }

    return { resData, error };
  };

  return {
    data,
    isLoading,
    get,
    add,
  };
};

export default useLogRoute;
